import React from "react";
// Components
import PersonalDetails from "../sectionWrapper/PersonalDetails";
import TravelDetails from "../sectionWrapper/TravelDetails";
import HealthDetails from "../sectionWrapper/HealthDetails";
import AirTravelDetails from "../sectionWrapper/AirTravelDetails";
import EmergencyContactDetails from "../sectionWrapper/EmergencyContactDetails";
import SectionAutoSaveWrapper from "../../refs/SectionAutoSaveWrapper";
// Assets
import { AiOutlineInfoCircle } from "react-icons/ai"; // example icon
import TranslationVolunteering from "../europeanSections/TranslationVolunteering";
import EuropeanAccommodation from "../europeanSections/EuropeanAccommodation";
import ConsentsAgreements from "../europeanSections/ConsentsAgreements";
import Choices from "../userForms/Choices";

export default function EuropeanForm({
  showPopup,
  sectionRefs,
  handleChange,
  formErrors,
  formData,
  setFormData,
  onChoiceChange,
  setFormErrors,
  outboundFlights,
  setOutboundFlights,
  inboundFlights,
  setInboundFlights,
  isInvited,
  onKnownUserChange,
  onCategoryChange,
  allParticipantsData,
  setParticipantOutboundFlights,
  setParticipantInboundFlights,
  fieldRefs,
  inviteFormData,
  setInviteFormData,
  onSectionExit,
}) {
  return (
    <div className="">
      {/* Personal Details */}
      <SectionAutoSaveWrapper
        sectionId="section1"
        onSectionExit={onSectionExit}
      >
        <section
          id="section1"
          ref={sectionRefs.section1}
          className="block sm:flex gap-8 justify-between px-4 sm:px-10 py-4 border-b border-sectionBorder"
        >
          <div className="w-full">
            <div className="mb-4">
              <h2 className="">Personal Details</h2>
              <div className="flex items-center gap-1 text-xs text-yellow-800">
                <AiOutlineInfoCircle size={14} className="text-yellow-600" />
                <p className="text-sm">
                  Please enter your first and last name as shown in your
                  passport.
                </p>
              </div>
            </div>
            <PersonalDetails
              formData={formData}
              handleChange={handleChange}
              formErrors={formErrors}
              inputRefs={fieldRefs}
            />
          </div>
        </section>
      </SectionAutoSaveWrapper>

      {/* Emergency Contact */}
      <SectionAutoSaveWrapper
        sectionId="section2"
        onSectionExit={onSectionExit}
      >
        <section
          id="section2"
          ref={sectionRefs.section2}
          className="block sm:flex gap-4 justify-between px-4 sm:px-10 py-4 bg-headerLight border-b border-headerBorder"
        >
          <div className="w-full">
            <h2 className="mb-4 w-full">Emergency Contact</h2>
            <EmergencyContactDetails
              formData={formData}
              handleChange={handleChange}
              formErrors={formErrors}
              inputRefs={fieldRefs}
            />
          </div>
        </section>
      </SectionAutoSaveWrapper>

      {/* Passport Information */}
      <section
        id="section3"
        ref={sectionRefs.section3}
        className="block sm:flex gap-8 justify-between px-4 sm:px-10 py-4 border-b border-sectionBorder"
      >
        <div className="w-full">
          <div className="mb-4">
            <h2 className="">Passport Information</h2>
          </div>
          <TravelDetails
            formData={formData}
            handleChange={handleChange}
            formErrors={formErrors}
            inputRefs={fieldRefs}
          />
        </div>
      </section>

      {/* Health Details */}
      <section
        id="section4"
        ref={sectionRefs.section4}
        className="px-4 sm:px-10 py-4 border-b bg-headerLight border-sectionBorder"
      >
        <h2 className="mb-4">Health Details</h2>
        <HealthDetails
          formData={formData}
          handleChange={handleChange}
          formErrors={formErrors}
          inputRefs={fieldRefs}
        />
      </section>

      {/* Accommodation Details */}
      <section
        id="section5"
        ref={sectionRefs.section5}
        className="px-4 sm:px-10 py-4 bg-headerLight border-b border-sectionBorder"
      >
        <div className="flex gap-2 items-center mb-2">
          <h2>Accommodation Details</h2>
        </div>
        <EuropeanAccommodation />
      </section>

      {/* Translation & Volunteering */}
      <section
        id="section6"
        ref={sectionRefs.section6}
        className="px-4 sm:px-10 py-4 border-b bg-headerLight border-sectionBorder"
      >
        <div className="flex gap-2 items-center mb-2">
          <h2>Translation & Volunteering</h2>
        </div>
        <TranslationVolunteering
          formData={formData}
          handleChange={handleChange}
          formErrors={formErrors}
          setFormData={setFormData}
        />
      </section>

      {/* Air Travel Details */}
      <section
        id="section7"
        ref={sectionRefs.section7}
        className="px-4 sm:px-10 py-4  border-b border-sectionBorder"
      >
        <div className="mb-4">
          <h2>Air Travel Details</h2>
          <div className="flex items-center gap-1 text-xs text-yellow-800">
            <AiOutlineInfoCircle size={14} className="text-yellow-600" />
            <p className="text-sm">
              Please complete this section after purchasing your flight ticket.
            </p>
          </div>
        </div>

        <AirTravelDetails
          outboundFlights={outboundFlights}
          setOutboundFlights={setOutboundFlights}
          inboundFlights={inboundFlights}
          setInboundFlights={setInboundFlights}
          formErrors={formErrors}
          handleChange={handleChange}
          setFormErrors={setFormErrors}
          copyOutBoundFlights={setParticipantOutboundFlights}
          copyInBoundFlights={setParticipantInboundFlights}
          allParticipantsData={allParticipantsData}
          inputRefs={fieldRefs}
        />
      </section>

      {/* Tour Pricing */}
      <section id="section8" ref={sectionRefs.section8} className="">
        <Choices
          showPopup={showPopup}
          handleChange={handleChange}
          formErrors={formErrors}
          formData={formData}
          onOptionChange={(opts) => {
            setFormData((prev) => ({
              ...prev,
              tourOptions: opts, // set only selected ones here
            }));
          }}
          onChoiceChange={(selected) => {
            setFormData((prev) => ({
              ...prev,
              travelerChoice: selected,
            }));
          }}
          setFormErrors={setFormErrors}
          allParticipantsData={""}
        />
      </section>

      {/* Consents Agreements */}
      <section
        id="section9"
        ref={sectionRefs.section9}
        className="px-4 sm:px-10 py-4 border-b bg-headerLight border-sectionBorder"
      >
        <ConsentsAgreements
          formData={formData}
          handleChange={handleChange}
          formErrors={formErrors}
        />
      </section>
    </div>
  );
}
